import axiosInstance from "../app/axios";
import UserPermissionDTO from "../shared/dtos/userPermissionDTO";

export const GetUserPrivileges = async (userId: number) => {
  const result = await axiosInstance.get(`user-permission/${userId}`);

  return result.data.data;
};

export const CreateUserPrivilege = async (
  userPermission: UserPermissionDTO,
) => {
  const result = await axiosInstance.post("user-permission", userPermission);

  return result.data.data;
};

export const UpdateUserPrivilege = async (
  userPermissionId: number,
  userPermission: UserPermissionDTO,
) => {
  const result = await axiosInstance.put(
    `user-permission/${userPermissionId}`,
    userPermission,
  );

  return result.data.data;
};
